// extracted by mini-css-extract-plugin
export var auto = "_2l-1";
export var spinner = "_2l-0";